import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { CourseCard } from '@/components/ui/data-display/cards/course-card/CourseCard';
import { GridCol } from '@/components/ui/layouts/grids/GridCol';

import { gridCol } from '@mage-ui/styled-system/recipes';
import { useContext } from 'react';
import { parseDateString } from 'utils/dates';

export const Course = ({ data, formPage }) => {
  const { st } = useContext(StaticTextContext);

  const courseType = data?.relations?.CourseType?.instances?.[0];
  const group = data?.relations?.Group?.instances?.[0];
  const lang = group?.relations?.Language?.instances?.[0];
  const courseParam = st('course.key');

  const infoData = [
    {
      name: st('register.name'),
      value: data?.fields?.title || data?.title,
      key: 'info-data-0',
    },
    {
      name: st('register.level'),
      value: Array.isArray(data?.relations?.Group?.instances)
        ? data?.relations?.Group.instances
            .map((g) => g.fields?.level)
            .filter(Boolean)
            .join(' / ')
        : '',
      key: 'info-data-1',
    },
    /*     {
      name: st('register.price'),
      value: data?.fields?.price ? `${data?.fields?.price} €` : '',
      key: 'info-data-2',
    }, */
    {
      name: st('register.startDate'),
      value: data?.fields?.date_start
        ? parseDateString(data?.fields?.date_start)
        : '',
      key: 'info-data-3',
    },
    {
      name: st('register.endDate'),
      value: data?.fields?.date_end
        ? parseDateString(data?.fields?.date_end)
        : '',
      key: 'info-data-4',
    },
    {
      name: st('register.schedule'),
      value: data?.relations?.Group?.instances?.[0]?.fields?.schedule,
      key: 'info-data-5',
    },
  ];

  return (
    <>
      <GridCol className={gridCol({ colSpanM: '4', colSpanL: '4' })}>
        <CourseCard
          data={{
            title: courseType?.fields?.title,
            name: lang?.fields?.name,
            iso: lang?.fields?.alias || lang?.fields?.iso,
            link_cta: st('register'),
            link_slug: formPage?.meta?.link
              ? `${formPage?.meta?.link}?${courseParam}=${data?.meta?.id}`
              : '',
            info_cta: `${st('register.more_info')} ${data?.fields?.title}`,
            info_slug:
              lang?.relations?.LanguagePageLink?.instances?.[0].meta?.link ||
              null,
            infoData: infoData,
          }}
        />
      </GridCol>
    </>
  );
};
